import { render, staticRenderFns } from "./CategoryPageProductsCount.vue?vue&type=template&id=996d8890&scoped=true&"
import script from "./CategoryPageProductsCount.vue?vue&type=script&lang=js&"
export * from "./CategoryPageProductsCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996d8890",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('996d8890')) {
      api.createRecord('996d8890', component.options)
    } else {
      api.reload('996d8890', component.options)
    }
    module.hot.accept("./CategoryPageProductsCount.vue?vue&type=template&id=996d8890&scoped=true&", function () {
      api.rerender('996d8890', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/CategoryPageProductsCount.vue"
export default component.exports